export type AssetDetailsTranslations = AssetDetailsGeneralTranslations &
  AssetDetailsAreaChartTranslations &
  AssetDetailsETFTranslations;

export type AssetDetailsGeneralTranslations = {
  CryptoAsset: string;
  MetalAsset: string;
  StockAsset: string;
  EtfAsset: string;
  EtcAsset: string;
  EquityStockAsset: string;
  EquityEtfAsset: string;
  EquityEtcAsset: string;
  EquityComplexEtfAsset: string;
  EquityComplexEtcAsset: string;
  FiatEarnAsset: string;
  marketCap: string;
  marketValue: string;
  youOwn: string;
  dailyHigh: string;
  assetFundSize: string;
  yearHigh: string;
  financials: string;
  dailyLow: string;
  volatility: string;
  yearLow: string;
  assetDetailOverview: string;
  viewRelatedTransactions: string;
  tradeButton: string;
  readLess: string;
  readMore: string;
  buy: string;
  sell: string;
  savingsPlan: string;
  errorAssetNotAvailableTitle: string;
  errorAssetNotAvailableSubtitle: string;
  inOneYear: string;
  inOneMonth: string;
  inOneWeek: string;
  in24Hours: string;
  inSixMonths: string;
  inMaxYears: string;
  averageBuyPrice: string;
  totalReturn: string;
  dailyReturn: string;
  weekly: string;
  islamicShariahCompliant: string;
  legacy: string;
  actionsHeader: string;
  anchorKeyFacts: string;
  anchorResearch: string;
  anchorActivity: string;
  priceStatisticsTitle: string;
  assetDetailsAboutSectionTitle: string;
  wkn: string;
  assetDetailsAboutSectionKidTitle: string;
};

export type AssetDetailsAreaChartTranslations = {
  last24h: string;
  lastWeek: string;
  lastMonth: string;
  lastYear: string;
  maxYears: string;
};

export type AssetDetailsETFTranslations = {
  underlyingAsset: string;
  assetName: string;
  assetProvider: string;
  perAnnum: string;
  assetTotalExpenseRatio: string;
  assetDistributionPolicy: string;
  assetReplicationMethod: string;
  isin: string;
  legalUrl: string;
};

export type StockAssetDetailsTranslations = {
  assetDetailBuy: string;
  assetDetailHold: string;
  assetDetailSell: string;
  assetDividendYield: string;
  assetDividendPerShare: string;
  assetRevenue: string;
  assetPeRatio: string;
  assetNetIncome: string;
  netIncome: string;
  dividendsTitle: string;
  dividendsDescription: string;
  assetDetailAnalystRatingsDescription: string;
  assetDetailAnalysRatingsTitle: string;
  assetDetailAnalystRatingsFactset: string;
  buy: string;
  sell: string;
  hold: string;
  noConsensus: string;
  assetDetailAnalystAvgTargetPrice: string;
  assetDetailAnalystTargetAboveCurrent: string;
  assetDetailAnalystTargetBelowCurrent: string;
  legalUrl: string;
};

export type AssetDetailsKeyFactsTranslations = {
  keyFactsTitle: string;
  marketCap: string;
  peRatio: string;
  earningsPerShare: string;
  ter: string;
  fundSize: string;
  distributionPolicy: string;
  replicationMethod: string;
  provider: string;
  perAnnum: string;
};

export enum AssetType {
  CRYPTO = 'CryptoAsset',
  STOCK = 'StockAsset',
  METAL = 'MetalAsset',
  ETF = 'EtfAsset',
  ETC = 'EtcAsset',
  EQUITY_STOCK = 'EquityStockAsset',
  EQUITY_ETF = 'EquityEtfAsset',
  EQUITY_ETC = 'EquityEtcAsset',
  EQUITY_COMPLEX_ETF = 'EquityComplexEtfAsset',
  EQUITY_COMPLEX_ETC = 'EquityComplexEtcAsset',
}
